<span [class]="spanClass()" [attr.aria-label]="tier() + ' gear tier'"></span>
